var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.483,
    viewBox: "0 0 22 22.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245778",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245778",
    d: "M10.435,12.611h0l-.87-1.245L2.64,1.461H5.621l5.588,7.993.87,1.245,7.264,10.39H16.362ZM19.342,0,12.231,8.266,6.551,0H0L8.589,12.5,0,22.483H1.941l7.51-8.729,6,8.729H22L13.093,9.52h0L21.283,0Z",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoX);
export default __webpack_public_path__ + "static/media/ico_x.a4accd201493ba0b9aef5ce3d75366d9.svg";
export { ForwardRef as ReactComponent };